import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Tooltip } from '../../Tooltip/Tooltip.es.js';
import { useCopyToClipboardContext } from '../CopyToClipboard.Context/index.es.js';

const CopyToClipboardTooltip = ({ children })=>{
    const [{ locale, isCopied, variant }] = useCopyToClipboardContext();
    return jsx(Tooltip, {
        className: classNames('cb-copy-to-clipboard-tooltip', `${variant}-variant`),
        content: isCopied ? locale.afterCopy : locale.beforeCopy,
        place: "bottom",
        size: "sm",
        width: "hug",
        children: jsxs("div", {
            children: [
                isCopied && jsx("span", {
                    "aria-live": "polite",
                    className: "sr-only",
                    role: "alert",
                    children: locale.afterCopy
                }),
                children
            ]
        })
    });
};
CopyToClipboardTooltip.displayName = 'CopyToClipboard.Tooltip';

export { CopyToClipboardTooltip, CopyToClipboardTooltip as default };
//# sourceMappingURL=CopyToClipboard.Tooltip.es.js.map
